import React, {useEffect, useState} from 'react';
import * as FloatingButtonStyle from "./floatingButton.module.scss"
import ButtonLink from "../buttonLink/buttonLink";
import {getRedirectionLink, pushToDataLayer} from "../../../utils/redirectToTryForFree";

function FloatingButton({page}) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollY > 800);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`${FloatingButtonStyle.floatingButton} ${isScrolled ? FloatingButtonStyle.floatingButton_visible : ''}`}>
      {page === 'agency' ?
        <ButtonLink
          href={`${process.env.GATSBY_AGENCY_SIGNUP}signup`}
          label='Try for free'
          target="_blank"
          extraClass='floating'
        />
        :
        <ButtonLink
          href={getRedirectionLink()}
          onClick={pushToDataLayer}
          label='Try for free'
          target="_blank"
          extraClass='floating'
        />
      }
    </div>
  );
}

export default FloatingButton;